"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteField = void 0;
var formik_material_ui_lab_1 = require("formik-material-ui-lab");
var formik_1 = require("formik");
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../utils");
var autocompleteDataFunctions_1 = require("./autocompleteDataFunctions");
exports.AutocompleteField = function (props) {
    var options = props.options, label = props.label, fieldName = props.fieldName, _a = props.multiple, multiple = _a === void 0 ? false : _a, _b = props.disableClearable, disableClearable = _b === void 0 ? false : _b, _c = props.required, required = _c === void 0 ? false : _c, _d = props.filterSelectedOptions, filterSelectedOptions = _d === void 0 ? false : _d, _e = props.getOptionLabel, getOptionLabel = _e === void 0 ? autocompleteDataFunctions_1.getOptionLabelDefault : _e, _f = props.getOptionSelected, getOptionSelected = _f === void 0 ? autocompleteDataFunctions_1.getOptionSelectedDefault : _f;
    var _g = formik_1.useFormikContext(), touched = _g.touched, errors = _g.errors;
    var fieldTouched = utils_1.getObjValueByDotProp(touched, fieldName);
    var fieldErrors = utils_1.getObjValueByDotProp(errors, fieldName);
    var renderInput = function (params) { return (react_1.default.createElement(core_1.TextField, __assign({}, params, { name: fieldName, error: fieldTouched && !!fieldErrors, helperText: fieldTouched && fieldErrors, label: label, variant: "outlined", color: "primary", required: required }))); };
    return (react_1.default.createElement(formik_1.Field, { component: formik_material_ui_lab_1.Autocomplete, fullWidth: true, size: "small", name: fieldName, options: options, multiple: multiple, disableClearable: disableClearable, filterSelectedOptions: filterSelectedOptions, getOptionLabel: getOptionLabel, getOptionSelected: getOptionSelected, renderInput: renderInput }));
};
